import { generateUrl } from "@nextcloud/router";
import { checkIfDarkTheme } from "../Functions/isDarkTheme.mjs";
function getAvatarUrl(user, options) {
  const size = (options?.size || 64) <= 64 ? 64 : 512;
  const guestUrl = options?.isGuest ? "/guest" : "";
  const themeUrl = options?.isDarkTheme ?? checkIfDarkTheme(document.body) ? "/dark" : "";
  return generateUrl(`/avatar${guestUrl}/{user}/{size}${themeUrl}?guestFallback=true`, {
    user,
    size
  });
}
export {
  getAvatarUrl as g
};
//# sourceMappingURL=getAvatarUrl-BGOeDmNO.mjs.map
